import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import {showContactPopup} from "../../actionCreators";
import PopupContact from "../Popups/PopupContact.js";

class Footer extends Component {

  handleShowContactPopup = (e) => {
    e.preventDefault();
    const {showContactPopup} = this.props;
    showContactPopup();
  };

  render() {
    const {handleShowContactPopup} = this;
    return (
      <Fragment>
        <footer className="footer">
          <div className="container">
            <div className="footer__inner">
              <div className="footer__item footer__contact">
                <a onClick={handleShowContactPopup} className="hero__link--contact-js" href="#">Kontaktiere uns</a>
              </div>
              <div className="footer__item footer__email">
                <h3>E-MAIL ADRESSE:</h3>
                <a href="mailto: info@moebelpost.de">info@moebelpost.de</a>
              </div>
              <div className="footer__item footer__phones">
                <h3>ERREICHBARKEIT:</h3>
                <ul>
                  <li>
                    <a href="tel: 0221 - 298 37 36 8">Tel: 0221 - 298 37 36 8</a>
                  </li>
                  <li>
                    <a href="fax: 0221 - 298 37 36 1">Fax: 0221 - 298 37 36 1</a>
                  </li>
                </ul>
              </div>
              <div className="footer__item footer__socials">
                <h3>Adresse:</h3>
                <ul className="social__list">
                  <li>Mathias-Brüggen-Straße 2, 50827 Köln</li>
                  {/*<li className="social__item">*/}
                  {/*  <a className="social__link" href="facebook.com" rel="nofollow" target="_blank">*/}
                  {/*    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="32">*/}
                  {/*      <path*/}
                  {/*        d="M11.75.99c-2.13 0-3.83.62-5.11 1.85-1.28 1.23-1.92 2.97-1.92 5.21v3.94H.02v5.34h4.7v13.71h5.64V17.33h4.68l.72-5.34h-5.4V8.58c0-.87.18-1.52.55-1.95.37-.43 1.08-.65 2.14-.65h2.89V1.21c-1-.14-2.4-.22-4.2-.22z"*/}
                  {/*        fill="#fff"></path>*/}
                  {/*    </svg>*/}
                  {/*  </a>*/}
                  {/*</li>*/}
                  {/*<li className="social__item">*/}
                  {/*  <a className="social__link" href="twitter.com" rel="nofollow" target="_blank">*/}
                  {/*    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 612 612" width="30" height="30">*/}
                  {/*      <path*/}
                  {/*        d="M612 116.258a250.714 250.714 0 0 1-72.088 19.772c25.929-15.527 45.777-40.155 55.184-69.411-24.322 14.379-51.169 24.82-79.775 30.48-22.907-24.437-55.49-39.658-91.63-39.658-69.334 0-125.551 56.217-125.551 125.513 0 9.828 1.109 19.427 3.251 28.606-104.326-5.24-196.835-55.223-258.75-131.174-10.823 18.51-16.98 40.078-16.98 63.101 0 43.559 22.181 81.993 55.835 104.479a125.556 125.556 0 0 1-56.867-15.756v1.568c0 60.806 43.291 111.554 100.693 123.104-10.517 2.83-21.607 4.398-33.08 4.398-8.107 0-15.947-.803-23.634-2.333 15.985 49.907 62.336 86.199 117.253 87.194-42.947 33.654-97.099 53.655-155.916 53.655-10.134 0-20.116-.612-29.944-1.721 55.567 35.681 121.536 56.485 192.438 56.485 230.948 0 357.188-191.291 357.188-357.188l-.421-16.253c24.666-17.593 46.005-39.697 62.794-64.861z"*/}
                  {/*        fill="#fff"></path>*/}
                  {/*    </svg>*/}
                  {/*  </a>*/}
                  {/*</li>*/}
                  {/*<li className="social__item">*/}
                  {/*  <a className="social__link" href="pinterest.com" rel="nofollow" target="_blank">*/}
                  {/*    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="32">*/}
                  {/*      <path*/}
                  {/*        d="M1.2 13.69c.13.66.33 1.31.58 1.95.26.64.62 1.21 1.1 1.71.47.49 1.02.83 1.63 1.01.18.04.28.06.31.06.26 0 .49-.27.67-.81.18-.54.27-.98.27-1.32 0-.11-.08-.29-.22-.55-.15-.26-.31-.53-.49-.82-.17-.29-.34-.68-.49-1.17-.15-.49-.22-1.01-.22-1.54 0-2.4.8-4.37 2.41-5.93 1.61-1.56 3.61-2.34 6.01-2.34 2.11 0 3.82.58 5.14 1.74 1.31 1.16 1.97 2.78 1.97 4.87 0 .57-.04 1.16-.12 1.8-.08.63-.2 1.3-.36 2-.16.7-.39 1.37-.68 2-.29.63-.63 1.2-1.01 1.72s-.85.93-1.41 1.23c-.56.3-1.18.45-1.83.45-.77 0-1.42-.25-1.96-.75s-.81-1.13-.81-1.89c0-.75.26-1.87.79-3.38.53-1.5.79-2.65.79-3.45 0-.75-.2-1.36-.61-1.85s-.98-.73-1.71-.73c-.96 0-1.75.44-2.37 1.32-.62.88-.94 1.82-.94 2.82 0 1.25.19 2.27.58 3.05-.08.36-.4 1.58-.94 3.67-.54 2.08-.94 3.81-1.2 5.19-.26 1.38-.39 2.62-.39 3.73 0 .37.09 1.5.27 3.39l.16.18.25-.09c.44-.6.82-1.12 1.12-1.56.3-.44.58-.91.83-1.4.25-.49.44-.87.58-1.13.13-.26.29-.69.47-1.28.18-.6.3-1.02.37-1.28s.21-.83.42-1.72c.22-.88.38-1.56.5-2.03.35.67.92 1.2 1.73 1.59.8.39 1.61.58 2.43.58 1.23 0 2.37-.23 3.4-.69 1.03-.46 1.9-1.08 2.61-1.86s1.31-1.68 1.8-2.7c.49-1.02.85-2.09 1.08-3.2.23-1.11.34-2.24.34-3.4 0-1.93-.51-3.65-1.53-5.18a9.933 9.933 0 0 0-3.98-3.49c-1.63-.8-3.39-1.2-5.29-1.2-1.24 0-2.45.16-3.63.47-1.19.31-2.3.78-3.33 1.41-1.03.63-1.94 1.37-2.73 2.22A9.53 9.53 0 0 0 1.7 8.12c-.45 1.15-.67 2.37-.67 3.68 0 .63.07 1.27.2 1.92z"*/}
                  {/*        fill="#fff"></path>*/}
                  {/*    </svg>*/}
                  {/*  </a>*/}
                  {/*</li>*/}
                </ul>
              </div>
            </div>
          </div>
          <div className="footer__copyright">
            Copyright © <script>document.write(+new Date().getFullYear());</script>2019
            <a href="http://rexit.info/" title="rex.it" target="_blank">
              Site by <span>Rex</span>
              <span>IT</span>
            </a>
            <p>All rights are reserved</p>
          </div>
        </footer>
        <PopupContact/>
      </Fragment>
    );
  }
}

export default connect(null, {showContactPopup})(Footer);


// WEBPACK FOOTER //
// ./src/components/Footer/index.js